import { siteQuery } from '@/api/queries'
import { Timeline } from '@/components/site/Timeline'
import { ErrorCard, LoadingCard } from '@/components/ui/StateCards'
import type { SalaIntent } from '@/lib/viewIntent'
import { useQuery } from '@tanstack/react-query'
import { t } from '@/lib/i18n'

type Intent = Extract<SalaIntent, { kind: 'timeline' }>

export function TimelineBody({ intent }: { intent: Intent }) {
  // The Timeline component lives on the SitePayload; we fetch the site
  // for a chosen date so the cursor follows what the user asked for.
  const date = intent.date ?? intent.date_to ?? intent.date_from ?? null
  const q = useQuery(siteQuery(intent.site_id, date))
  if (q.isPending) return <LoadingCard label={t('Loading timeline…')} />
  if (q.isError || !q.data) return <ErrorCard message={t('Could not load timeline.')} />

  // Display-only in the sala: phase closing is a site-dashboard action,
  // not something we want the chat-driven view to trigger. If the user
  // wants to close a phase they go back to the dashboard.
  return (
    <Timeline
      timeline={q.data.timeline}
      closeVotesManualThreshold={q.data.close_votes_manual_threshold}
      onClosePhase={noop}
      closing={EMPTY_SET}
      selectedDate={date ?? undefined}
    />
  )
}

const EMPTY_SET: Set<number> = new Set()
const noop = () => {}
